import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { useAcademicsService } from '../../../../apis/academics/useAcademicsService';
import { IAcademicsLibraryResponse } from '../../../../apis/academics/academicsLibrary.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getAcademicsLibraryKey = 'get-academics-library';

export const useAcademicsLibraryHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<IAcademicsLibraryResponse, TQueryError>
): UseQueryResult<IAcademicsLibraryResponse, TQueryError> => {
  const { getAcademicsLibrary } = useAcademicsService();

  return useQuery<IAcademicsLibraryResponse, TQueryError>({
    queryKey: [getAcademicsLibraryKey],
    queryFn: () => getAcademicsLibrary(),
    enabled: true,
    ...options,
  });
};
